import { Component, OnDestroy, OnInit, Renderer2, AfterViewInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core';
import { finalize } from 'rxjs/operators';
import { RandomUsernameService } from 'app/core/random-username.service';
import { ModalService } from 'app/shared/modal.service';
import { TranslateService } from '@ngx-translate/core';
import dbQuestions from '@app/shared/data/security-question.data';

@Component({
  selector: 'app-reset-password-modal',
  templateUrl: './reset-password-modal.template.html',
  styleUrls: [
    './reset-password-modal.template.scss',
  ],
  animations: []
})
export class ResetPasswordModalComponent implements OnInit, OnDestroy, AfterViewInit {
  form: FormGroup;
  loaded = false;
  errors: string = null;
  success: string = null;

  isValid = false;

  secured: boolean = false;
  question: string = null;

  public qOptions = dbQuestions;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private auth: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private nick: RandomUsernameService,
    private translate: TranslateService,
    private modalService: ModalService,
    protected renderer: Renderer2,
  ) {
  }

  public ngOnInit() {
    this.createForm();
  }

  public ngAfterViewInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['passwordResetToken']) {
        this.auth.validatePasswordResetToken(params['passwordResetToken']).pipe(finalize(() => {
        })).subscribe((response) => {
          if (response.isValid) {
            this.secured = response.secured;
            this.question = response.securityQuestion;
            this.form.get('token').setValue(params['passwordResetToken']);
            this.form.get('question').setValue(this.question);
            this.isValid = true;
          } else {
            // FIXME: We do not support pop-ups on top of other pop-ups correctly.
            // this.modalService.openAlert({
            //   title: 'Error',
            //   text: 'Password reset token is invalid or expired.',
            // });
          }

          this.loaded = true;
        });
      }
    });
  }

  public ngOnDestroy() {
  }

  public resetPassword(): void {
    this.auth.resetPassword(this.form.value).pipe(finalize(() => {
    })).subscribe(() => {
        this.modalService.openAlert({
          title: 'Success',
          text: 'Your password has been changed successfully. You can log in now.',
        }).result.then(() => {
          this.router.navigate(['/', { outlets: { modal: 'login' } }]);
        });
    }, (error) => {
      if (error.status < 500) {
          this.modalService.openAlert({
            title: 'Error',
            text: error.json().message,
          });
      } else {
          this.modalService.openAlert({
            title: 'Error',
            text: 'Some unknown server error happened.',
          });
      }
    });
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      token: ['', Validators.required],
      password: ['', Validators.required],
      passwordConfirmation: ['', Validators.required],
      question: this.question,
      answer: null,
    }, {
      validator: (AC: AbstractControl): void => {
        const password = AC.get('password').value;
        const confirmPassword = AC.get('passwordConfirmation').value;
        if (password !== confirmPassword) {
          AC.get('passwordConfirmation').setErrors({ MatchPassword: true });
        } else {
          return null;
        }
      },
    });
  }

  public getQuestion(question: string): string {
    const items = this.qOptions.find((item) => item.option === question);
    if (items) {
      return items.value;
    }
    return null;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/reset-password/reset-password-modal.component.ts